import {Component} from '@angular/core';

@Component({
  selector: 'app-background-lines',
  templateUrl: './background-lines.component.html'
})
export class BackgroundLinesComponent {
}
